import { Bed, Building2, Activity, Microscope, Pill, Cross, Ambulance } from "lucide-react";
import { FACILITIES, HOSPITAL } from "../lib/hospitalData";

const iconFor = (name) => {
  const n = name.toLowerCase();
  if (n.includes("ward") || n.includes("rooms") || n.includes("bed")) return Bed;
  if (n.includes("emergency")) return Ambulance;
  if (n.includes("icu") || n.includes("cicu") || n.includes("post-icu")) return Activity;
  if (n.includes("operation") || n.includes("ot")) return Cross;
  if (n.includes("cath")) return Activity;
  if (n.includes("laboratory") || n.includes("cssd")) return Microscope;
  if (n.includes("pharmacy")) return Pill;
  return Building2;
};

export default function Facilities() {
  return (
    <main data-testid="page-facilities">
      <section className="bg-brand-cream relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-40" />
        <div className="container-x py-14 md:py-28 relative">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold">Facilities & Infrastructure</div>
          <h1 className="font-display text-[34px] sm:text-5xl lg:text-6xl font-bold text-brand-navy-deep mt-4 max-w-4xl leading-[1.05]">
            A <span className="italic text-brand-crimson">75-bed</span> hospital, built around the patient.
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-slate-700 max-w-3xl leading-relaxed">
            From the OPD to the Cath Lab, every corner of {HOSPITAL.shortName} is designed for clinical efficiency, comfort and timely emergency response.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20" data-testid="facilities-grid">
        <div className="container-x grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {FACILITIES.map((f, i) => {
            const Icon = iconFor(f.name);
            return (
              <div key={f.name} className={`card-lift bg-white border border-border rounded-2xl p-5 md:p-6 flex items-start gap-4 reveal reveal-${(i%5)+1}`}>
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-brand-navy/8 flex items-center justify-center text-brand-navy-deep shrink-0">
                  <Icon className="w-5 h-5 md:w-6 md:h-6" />
                </div>
                <div>
                  <div className="font-display text-base md:text-lg text-brand-navy-deep leading-snug">{f.name}</div>
                  {f.count && <div className="text-xs md:text-sm text-brand-crimson font-semibold mt-1.5">{f.count}</div>}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-14 md:py-20 bg-brand-cream">
        <div className="container-x grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 text-center">
          {[
            { label: "Total Beds", value: "75" },
            { label: "Operation Theatres", value: "Major + Minor" },
            { label: "Critical Care Beds", value: "ICU 11 · CICU 3" },
          ].map((s, i) => (
            <div key={s.label} className={`bg-white border border-border rounded-2xl py-8 md:py-10 px-4 reveal reveal-${i+1}`}>
              <div className="font-display text-3xl md:text-5xl font-bold text-brand-navy-deep">{s.value}</div>
              <div className="text-[10.5px] md:text-xs uppercase tracking-widest text-slate-600 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
